import { createSelector } from '@reduxjs/toolkit'
import { Service } from '@/models/service'
import { getBoughtServicesTotal } from '@/utils/timeSchedules'
import { cartSlice } from '..'

export const serviceQuantitySelector = createSelector(
  [
    cartSlice.selectors.cartReservations,
    (_: unknown, service: Service) => service.serviceId,
  ],
  (cartReservations, serviceId): number => {
    if (cartReservations.length === 0) {
      return 0
    }
    const [firstReservation] = cartReservations
    return getBoughtServicesTotal(firstReservation.boughtServices[serviceId])
  }
)
